module.exports = __webpack_public_path__ + "img/xmasParty7.7f95a828.jpg";